var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 326,
    height: 167,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E4",
    fillRule: "evenodd",
    d: "M6 0h320v167H6c-3.314 0-6-2.686-6-6V6c0-3.314 2.686-6 6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M192.625 109.875c3.728 0 6.75-3.022 6.75-6.75v-40.5c0-3.728-3.022-6.75-6.75-6.75h-58.5c-3.728 0-6.75 3.022-6.75 6.75v40.5c0 3.728 3.022 6.75 6.75 6.75h58.5zm-49.5-46.125c4.349 0 7.875 3.526 7.875 7.875s-3.526 7.875-7.875 7.875-7.875-3.526-7.875-7.875 3.526-7.875 7.875-7.875zm-6.75 37.125v-6.75l10.057-10.057c.659-.659 1.727-.659 2.386 0l7.807 7.807 19.057-19.057c.659-.659 1.727-.659 2.386 0l12.307 12.307v15.75h-54z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoimage);
export default __webpack_public_path__ + "static/media/noimage.7025db562f67f8ba87a10b5c1569dd4d.svg";
export { ForwardRef as ReactComponent };